var map = {
	"./test_game_image1.webp": 63299,
	"./test_game_image10.webp": 20732,
	"./test_game_image11.webp": 58150,
	"./test_game_image2.webp": 25161,
	"./test_game_image3.webp": 25937,
	"./test_game_image4.webp": 91645,
	"./test_game_image5.webp": 92587,
	"./test_game_image6.webp": 26456,
	"./test_game_image7.webp": 42213,
	"./test_game_image8.webp": 597,
	"./test_game_image9.webp": 92217
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11192;